import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderBarcodeComponent } from './dynamic-page-builder-barcode.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderBarcodeDesignComponent } from './barcode-design/page-builder-barcode-design.component';

@NgModule({
    declarations: [
        PageBuilderBarcodeDesignComponent, DynamicPageBuilderBarcodeComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderBarcodeComponent
    ]
})
export class PageBuilderBarcodeModule {}